import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminLayout from './components/Layout/AdminLayout';
import Login from './pages/Auth/Login';
import ProtectedRoute from './routes/ProtectedRoute';
import Loading from './components/Common/Loading';

const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const PetTypes = lazy(() => import('./pages/PetTypes/PetTypes'));
const PetBreeds = lazy(() => import('./pages/PetBreeds/PetBreeds'));
const Countries = lazy(() => import('./pages/Countries/Countries'));
const States = lazy(() => import('./pages/States/States'));
const Cities = lazy(() => import('./pages/Cities/Cities'));
const Features = lazy(() => import('./pages/Features/Features'));
const Pets = lazy(() => import('./pages/Pets/Pets'));
const Users = lazy(() => import('./pages/Users/Users'));
const Subscriptions = lazy(() => import('./pages/Subscriptions/Subscriptions'));
const PaymentTest = lazy(() => import('./pages/PaymentTest/PaymentTest'));
const CmsPages = lazy(() => import('./pages/CmsPages/CmsPages'));
const HelpSupport = lazy(() => import('./pages/HelpSupport/HelpSupport'));
const Doctors = lazy(() => import('./pages/Doctors/Doctors'));
const Appointments = lazy(() => import('./pages/Appointments/Appointments'));
const Notifications = lazy(() => import('./pages/Notifications/Notifications'));

function App() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <Suspense fallback={<Loading fullPage />}>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="pet-types" element={<PetTypes />} />
          <Route path="pet-breeds" element={<PetBreeds />} />
          <Route path="countries" element={<Countries />} />
          <Route path="states" element={<States />} />
          <Route path="cities" element={<Cities />} />
          <Route path="features" element={<Features />} />
          <Route path="pets" element={<Pets />} />
          <Route path="users" element={<Users />} />
          <Route path="subscriptions" element={<Subscriptions />} />
          <Route path="payment-test" element={<PaymentTest />} />
          <Route path="cms-pages" element={<CmsPages />} />
          <Route path="help-support" element={<HelpSupport />} />
          <Route path="doctors" element={<Doctors />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Suspense>
  );
}

export default App;
